import React from 'react'
import { Typography } from '@material-ui/core'
import { Section } from './Section'

type Props = {
  title: string
  subtitle1: string
  subtitle2: string
}

export function ReportHeader({
  title,
  subtitle1,
  subtitle2,
}: Props): React.ReactElement {
  return (
    <Section>
      <Typography variant="h4">{title}</Typography>
      <Typography variant="h5">{subtitle1}</Typography>
      <Typography variant="h6">{subtitle2}</Typography>
    </Section>
  )
}
